import { PopoverOrigin } from "@mui/material"
import {
  GridCellEditCommitParams,
  GridCellEditStopParams,
  GridDensity,
  GridEventListener,
  GridRowModel,
  GridRowParams,
  GridSelectionModel,
  MuiEvent
} from "@mui/x-data-grid-pro"

import { TableApiRef } from "./api/types"
import {ITableColumn, ProgressColumnType} from "./components/TableColumns"
import { DrawerFields } from "./components/TableDrawer"

export { ITableColumn, DrawerFields }

export enum Sort {
  asc = "asc",
  desc = "desc",
}

export interface IFetchArgs {
  page: number,
  pageSize: number,
  search?: string,
  filters: any,
  sort?: string
}

export interface TableProps {
  tableId: string;
  apiRef?: TableApiRef;
  rowClickHandler?: GridEventListener<"rowClick">;
  cellClickHandler?: GridEventListener<"cellClick">;
  noResultsText?: string;
  noResultsDesc?: string;
  noFilteredItemsText?: string;
  noFilteredItemsDesc?: string;
  onFetchRequested: (event: IFetchArgs) => void;
  getRowClassName?: (row: any) => any;
  handleSort?: (event: any) => void;
  appearance?: any;
  legend?: any; // tableLegend

  editMode?: "cell" | "row";
  sortingMode?: "server" | "client";
  density?: GridDensity;
  disableAutoHeight?: boolean;

  enableDrawer?: boolean; // enableInfoIcon
  enableToolbar?: boolean;
  enableFilters?: boolean;
  defaultFilters?: any;
  enablePagination?: boolean;
  enableColumnMenu?: boolean;
  enableCheckboxSelection?: boolean;

  isRowSelectable?: (params: GridRowParams) => boolean;
  treeData?: boolean;
  groupingColDef?: any;
  getTreeDataPath?: (row: any) => string[];

  columns: ITableColumn[];
  actionsColumnDef?: ITableColumn;
  columnsEnableFirstColumnWidth?: boolean; // enableFirstColumnWidth

  columnsCustomIconColumn?: Partial<ITableColumn>; // customIcon
  columnsStatusType?: string; // statusType
  progressType?: ProgressColumnType;

  rows: any[];
  total: number;
  totalProgress?: {
    submitted: number;
    percentage: string;
    total: number;
    maxTotal: number;
  };
  isLoading: boolean;

  page?: number;
  pageSize?: number;
  rowsPerPageOptions?: number[];

  searchDisabled?: boolean;
  searchPlaceholder?: string;

  drawerContainerRef?: any;
  drawerFields?: DrawerFields;

  toolbarButtonLeft?: any;
  toolbarButtonRight?: any;

  selectionInitial?: any[]; // selectedRows
  selectionAllowSelectAll?: boolean; // disallowSelectAll
  disableSelectionOnClick?: boolean; // disableSelectionOnClick
  onSelectionModelChange?: (model: GridSelectionModel) => void; // onRowSelected
  filters?: (props?: any) => any; // renderFilters
  filtersPopover?: {
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
  },
  onCellEditStop?: (params: GridCellEditStopParams, value: string) => void;
  onCellEditCommit?: (params: GridCellEditCommitParams, event: MuiEvent) => void;
  processRowUpdate?: (newRow: GridRowModel) => any;
  onProcessRowUpdateError?: (error: any) => any;
  CustomRow?: (props: any) => any;
}

export const getPropsDefaults = (): TableProps => {
  return {
    tableId: "",
    columns: [],
    columnsEnableFirstColumnWidth: true,

    enableDrawer: true,
    enableToolbar: true,
    enablePagination: true,
    enableFilters: true,
    enableColumnMenu: true,
    enableCheckboxSelection: false,

    columnsStatusType: "",

    page: 0,
    pageSize: 100,
    rowsPerPageOptions: [10, 30, 50, 100],

    rows: [],
    total: 0,
    isLoading: false,

    drawerContainerRef: null,
    drawerFields: { title: "", overview: {}, details: {} },

    filters: (props: any): any => {},
    filtersPopover: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    },

    getRowClassName: (row: any): any => {},
    handleSort: (event: any): void => {},
    noResultsText: "",
    onFetchRequested: (event: IFetchArgs): void => {},
    rowClickHandler: (data: any, event: any): void => {},
    searchDisabled: false,
    selectionAllowSelectAll: false,
    disableSelectionOnClick: true,
    selectionInitial: [],
    onSelectionModelChange: (model: GridSelectionModel) => {},
  }
}

export enum LifecycleState {
  Created = 0,
  Ready = 3,
}

export interface EditRowProps {
}
